import React, { Component } from 'react';

import '../css/components/Addresses.css';

class Addresses extends Component {
  render() {
    return (
        <div className="contact">
            <div>
                <h6>Nous écrire :</h6>
                <address>
                    ARCA Computing<br/>
                    74 rue Georges Bonnac - Tour 3<br/>
                    33&nbsp;000 BORDEAUX
                </address>
            </div>
        </div>
    );
  }
}

export default Addresses;



// WEBPACK FOOTER //
// ./src/components/Addresses.js